/**
 * ReviewSection - 用户评论卡片渲染
 * reviews数据由Mpro.liquid页面传入
 */
var ReviewSection = {
  reviews: [],

  init: function () {
    var grid = document.getElementById('reviewGrid');
    if (!grid) return;

    var html = '';
    this.reviews.forEach(function (review) {
      html += '<div class="flex flex-col bg-white rounded-xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-md transition-shadow">';
      html += '<div class="relative aspect-square w-full bg-gray-100 overflow-hidden cursor-pointer group">';
      html += '<img src="' + review.image + '" alt="Review" class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />';
      html += '</div>';
      html += '<div class="p-4 flex-1 flex flex-col">';
      html += '<div class="flex items-center gap-2 mb-1">';
      html += '<span class="font-bold text-gray-900">' + review.name + '</span>';
      html += '<svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>';
      html += '<span class="text-xs text-gray-500 ml-auto">' + review.date + '</span>';
      html += '</div>';
      html += '<div class="flex text-yellow-400 mb-3">';
      for (var i = 0; i < 5; i++) {
        if (i < review.rating) {
          html += '<svg class="w-3 h-3 fill-current" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>';
        } else {
          html += '<svg class="w-3 h-3 text-gray-300" viewBox="0 0 20 20" fill="none" stroke="currentColor"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>';
        }
      }
      html += '</div>';
      html += '<p class="text-sm text-gray-600 line-clamp-4">' + review.text + '</p>';
      html += '</div></div>';
    });

    grid.innerHTML = html;
  }
};
